import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getRootUrl } from 'helpers/url';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

var Card = /*#__PURE__*/function (_Component) {
  _inherits(Card, _Component);

  var _super = _createSuper(Card);

  function Card(props) {
    var _this;

    _classCallCheck(this, Card);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "output", function () {
      var _this$props = _this.props,
          target = _this$props.target,
          type = _this$props.type,
          url = _this$props.url;
      var isExternal = !!(target && target.indexOf('http') > -1);
      var isInternal = !!(target && !isExternal);

      if (isExternal) {
        return /*#__PURE__*/React.createElement("a", {
          href: target,
          target: "_blank",
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      } else if (isInternal) {
        return /*#__PURE__*/React.createElement(Link, {
          to: target,
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      }

      if (_this.props.onClick != null && target == null) {
        return /*#__PURE__*/React.createElement("a", {
          onClick: _this.props.onClick,
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      } // console.warn('Deprecation warning: Missing target attribute for card. Please use an internal or external link in prop target.');
      // TODO: Remove the type checks below and make sure all cards have a
      // target attribute. Target will work with both external and internal
      // links and figures out how to handle them (based on http or not in url).


      if (_this.props.type === 'task') {
        return /*#__PURE__*/React.createElement(Link, {
          to: "".concat(getRootUrl(), "assignment/").concat(_this.props.id),
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      } else if (_this.props.type === 'planning') {
        return /*#__PURE__*/React.createElement(Link, {
          to: "".concat(getRootUrl(), "plan/").concat(_this.props.id),
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      } else if (_this.props.type === 'news') {
        return _this.props.item.id != 0 ? /*#__PURE__*/React.createElement(Link, {
          to: "news/".concat(_this.props.item.id),
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children) : /*#__PURE__*/React.createElement("a", {
          href: _this.props.item.section.classroomUrl,
          target: "_blank",
          className: "card card-".concat(_this.state.type)
        }, _this.props.children);
      } else if (_this.props.type === 'preschooldocument') {
        return _this.props.item.id != 0 ? /*#__PURE__*/React.createElement(Link, {
          to: "preschooldocument/".concat(_this.props.item.id),
          className: "card card-".concat(_this.state.type),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children) : /*#__PURE__*/React.createElement("a", {
          href: _this.props.item.section.classroomUrl,
          target: "_blank",
          className: "card card-".concat(_this.state.type)
        }, _this.props.children);
      } else if (_this.props.type === 'schedule') {
        return /*#__PURE__*/React.createElement(Link, {
          to: "".concat(getRootUrl(), "lesson/").concat(_this.props.id),
          className: "card card-".concat(_this.state.type, " ").concat(_this.props.className),
          style: _objectSpread({
            borderLeftColor: _this.state.color
          }, _this.props.style)
        }, _this.props.children);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "card card-".concat(_this.state.type),
        style: _objectSpread({
          borderLeftColor: _this.state.color
        }, _this.props.style)
      }, _this.props.children);
    });

    _this.state = {
      color: _this.props.hasOwnProperty('color') ? _this.props.color : '',
      type: _this.props.hasOwnProperty('type') ? _this.props.type : 'standard'
    };
    return _this;
  }

  _createClass(Card, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "card-outer",
        key: this.props.id
      }, this.output());
    }
  }]);

  return Card;
}(Component);
/**
* Cards container
* Displays cards in multiple columns based on screen width.
* @export CardsContainer
*/


export { Card as default };
export var CardsContainer = function CardsContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "cards-container"
  }, children);
};
/**
* Card title
*/

export var CardTitle = function CardTitle(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "card_title"
  }, children);
};
/**
* Card subtitle
*/

export var CardSubtitle = function CardSubtitle(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "card_subtitle"
  }, children);
};
/**
* Card description
*/

export var CardDescription = function CardDescription(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "card_description"
  }, children);
};
/**
* Card footer
*/

export var CardFooter = function CardFooter(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, children);
};